import request from '@/sheep/request';



export const doReport = (data: any) => {
	return request({
		url: '/wish/report/submit',
		method: 'POST',
		data: data
	});
}
